export function showBanner(a) {
    if (a.indexOf("http://localhost") !== -1 || a.indexOf("https://localhost") !== -1  || a.indexOf("127.0.0.1") !== -1) {
        showBannerLocal(a);
        return;
    }
    console.log(`%c
  ______    _            _        _____ _                 _
 |  ____|  (_)          | |      / ____| |               | |
 | |__ _ __ ___   _____ | | __ _| |    | | ___  _   _  __| |
 |  __| '__| \\ \\ / / _ \\| |/ _\` | |    | |/ _ \\| | | |/ _\` |
 | |  | |  | |\\ V / (_) | | (_| | |____| | (_) | |_| | (_| |
 |_|  |_|  |_| \\_/ \\___/|_|\\__,_|\\_____|_|\\___/ \\__,_|\\__,_|
 
 Guten tag, was machst du hier? Bitte nicht anfassen :)

 ` + a + `
                               `, "font-family:monospace")
}

export function showBannerLocal(a) {
    console.log(`%c

   __      _            _        _____ _                 _ 
  / _|    (_)          | |      / ____| |               | |
 | |_ _ __ ___   _____ | | __ _| |    | | ___  _   _  __| |
 |  _| '__| \\ \\ / / _ \\| |/ _\` | |    | |/ _ \\| | | |/ _\` |
 | | | |  | |\\ V / (_) | | (_| | |____| | (_) | |_| | (_| |
 |_| |_|  |_| \\_/ \\___/|_|\\__,_|\\_____|_|\\___/ \\__,_|\\__,_|
           | |                              | |            
         __| | _____   ___ __ ___   ___   __| | ___        
        / _\` |/ _ \\ \\ / / '_ \` _ \\ / _ \\ / _\` |/ _ \\       
       | (_| |  __/\\ V /| | | | | | (_) | (_| |  __/       
        \\__,_|\\___| \\_/ |_| |_| |_|\\___/ \\__,_|\\___|       
                                                           
 Guten tag, was machst du hier? Bitte anfassen :)

 ` + a + `
                               `, "font-family:monospace")
}


// WEBPACK FOOTER //
// ./src/scripts/random/banner.js